export default "__VITE_ASSET__04a195ff__"